// extracted by mini-css-extract-plugin
export default {"columns":"signup-form_columns__ov404"};